import { useState } from 'react';

import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import classes from './Property.module.css';
import TimeSlot from './TimeSlot';

import * as actionTypes from '../../store/actions/index';

const AddTimeSlot = ({ onBackClick, selectedProperties, onTourClick }) => {
  const nextDayDate = new Date().setDate(new Date().getDate());
  const selectedPropertiesCount = selectedProperties?.filter(
    (option) => option.isSelectedForTour,
  )?.length;

  const timeSlotOption = {
    selectedDate: nextDayDate,
    selectedTime: 'Morning',
    // selectedZone: 'EST',
  };

  const dispatch = useDispatch();

  const [timeSlots, setTimeSlots] = useState([{ ...timeSlotOption, slotId: uuidv4() }]);

  const summary = `Select time slot:`;
  const proprtyCount =
    selectedPropertiesCount == 1
      ? selectedPropertiesCount + ` property`
      : selectedPropertiesCount + ` properties`;
  const summarySubHeader =
    `Advice: As you have chosen  ` +
    proprtyCount +
    `  for tour, please choose up to 3 preferred slots below for touring the properties`;
  const summarySubHeader2 = `Morning: 9AM to 12PM, Afternoon: 12PM to 5PM`;
  const backClickHandler = () => {
    onBackClick();
  };

  const tourClickHandler = () => {
    const formatDatefromTimeStamp = (timeStamp) => {
      const date = new Date(timeStamp);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Convert month to a zero-padded string
      const day = String(date.getUTCDate()).padStart(2, '0'); // Convert day to a zero-padded string

      return `${year}-${month}-${day}`;
    };

    const timeSlotforSchedule = timeSlots.map((timeSlot) => {
      const { selectedDate, selectedTime, selectedZone } = timeSlot;

      return `${formatDatefromTimeStamp(selectedDate)} - ${selectedTime}`;
    });

    const timeSlotString = timeSlotforSchedule.join(',');

    const selectedPropertiesForTour = selectedProperties
      .filter((property) => property.isSelectedForTour)
      .map((property) => ({
        id: property.id,
        tourRequestedDate: timeSlotString,
      }));

    dispatch(actionTypes.scheduleTour(selectedPropertiesForTour));
    onTourClick();
  };

  const addSlotClickHandler = () => {
    setTimeSlots((prev) => [...prev, { ...timeSlotOption, slotId: uuidv4() }]);
  };
  const deleteSlotClickHandler = (timeSlot) => {
    const newFormValues = [...timeSlots];
    const updatedSlots = newFormValues?.filter((slot) => slot?.slotId !== timeSlot?.slotId);

    setTimeSlots(updatedSlots);
  };

  const onSlotChange = (slot) => {
    setTimeSlots((prev) => {
      return prev?.map((obj) => {
        if (obj?.slotId === slot?.slotId) {
          return { ...obj, ...slot };
        }

        return obj;
      });
    });
  };

  return (
    <>
      <div className={classes.heading}>
        <h4>Request for Tour </h4>
      </div>

      <div className={`${classes.summaryHeader} ${classes.headerTimeSlot}`}>
        <div>
          <div>{summary}</div>
          <div className={`${classes.summarySubHeader}`}>
            {summarySubHeader}
            <br />
            {summarySubHeader2}
          </div>
        </div>
        <div>
          <button
            className={`${classes.button} ${classes.primary}`}
            disabled={timeSlots.length > 2 ? true : false}
            onClick={addSlotClickHandler}
          >
            Add Slot
          </button>
        </div>
      </div>

      <div className={classes['properties_container']}>
        <div className={classes.timeSlotContainer}>
          {timeSlots?.map((timeSlot, index) => (
            <TimeSlot
              key={timeSlot?.slotId}
              slotIndex={index}
              timeSlotOptions={timeSlot}
              onSlotOptionsChange={onSlotChange}
              onDeleteTimeSlot={() => deleteSlotClickHandler(timeSlot)}
            />
          ))}
        </div>
      </div>

      <div className={classes.buttonContainer}>
        <h5 className={classes.pageNo}>2 of 2</h5>
        <button className={`${classes.button} ${classes.secondary}`} onClick={backClickHandler}>
          Back
        </button>
        <button className={`${classes.button} ${classes.primary}`} onClick={tourClickHandler}>
          Request Tour
        </button>
      </div>
    </>
  );
};

export default AddTimeSlot;
